import { Form } from "@circle-react-uikit/Form";
import { Controller, useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { CommunityMemberSelect } from "@/react/components/SettingsApp/CompassCompat/CommunityMemberSelect";
import { userIsAdminOrModeratorOfSpace } from "@/react/helpers/spaceHelpers";
import type { Space } from "@/react/types/Space";

interface FieldsProps {
  space?: Space;
}
export const Fields = ({ space }: FieldsProps) => {
  const { control } = useFormContext();
  const canChangeAuthor = !!space && userIsAdminOrModeratorOfSpace(space);
  return (
    <>
      <Form.Item
        variant="extra-bottom-margin"
        className="!pt-3"
        hideBorder
        name="slug"
        fullWidth
        translationRoot="post"
        hidePlaceholder
        hideDescription
        tooltipText={t("post.slug_description")}
      >
        <Form.Input name="slug" autoComplete="off" />
      </Form.Item>
      {canChangeAuthor && (
        <Form.Item
          variant="extra-bottom-margin"
          className="!pt-4"
          hideBorder
          name="user_id"
          labelClassName="!text-label-sm mb-2"
          translationRoot="post"
          fullWidth
          hideDescription
          tooltipText={t("post.user_id_description")}
        >
          <Controller
            control={control}
            name="user_id"
            render={({ field: { onChange, value } }) => (
              <CommunityMemberSelect
                direction="up"
                name="user_id"
                onChange={(item: { value: unknown }) => onChange(item.value)}
                value={typeof value === "number" ? value : null}
                valueField="user_id"
              />
            )}
          />
        </Form.Item>
      )}
    </>
  );
};
